import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { TabHeader } from '../../utils/constant';
import { StyledTabIndicator } from './styled/StyledTabIndicator';
import { goToStep, goToStepThroughNav } from 'src/features/stepper/stepperSlice';
import { Typography } from '../new/Typography';
import { useFormStepNavigation } from 'src/pages/create-notice/hooks/useFormNavigation';

interface BkTabsProps {
  tabs: TabHeader[] | undefined;
  currentTabIndex: number;
}

const BkTabs: React.FC<BkTabsProps> = ({ tabs, currentTabIndex }) => {
  const dispatch: AppDispatch = useDispatch();

  const { navigateToIndex } = useFormStepNavigation();

  const renderCustomTab = (label: string, tabIndex: number) => {
    const hasNotYetVisitedPage = currentTabIndex < tabIndex;
    const hasVisitedPage = currentTabIndex > tabIndex;

    return (
      <div
        style={{
          display: 'flex',
          gap: '0.875rem',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {!hasNotYetVisitedPage && (
          <StyledTabIndicator hasVisitedPage={hasVisitedPage}>{tabIndex + 1}</StyledTabIndicator>
        )}
        <Typography
          sx={{ fontWeight: 500, color: hasVisitedPage ? '#000' : hasNotYetVisitedPage ? '#b8b9bc' : '#436eb2' }}
        >
          {label}
        </Typography>
      </div>
    );
  };

  const tabClickHandler = (tabIndex: number) => {
    if (tabIndex < currentTabIndex) {
      if (tabs && currentTabIndex === tabs.length - 1) {
        dispatch(goToStep(tabIndex));
      } else {
        dispatch(goToStepThroughNav(tabIndex));
      }
      navigateToIndex(tabIndex);
    }
  };

  return (
    <Tabs
      value={currentTabIndex}
      aria-label="basic tabs example"
      classes={{
        indicator: 'indicator',
      }}
      orientation="vertical"
      variant="standard"
      sx={{
        '& .MuiTab-root': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          padding: '0rem',
        },
        '& .indicator': {
          display: 'none',
          backgroundColor: 'transparent',
          '& > span': {
            maxWidth: '7.5rem',
            width: '100%',
            backgroundColor: '#3D5AFD',
            borderRadius: '0.625rem',
          },
        },
      }}
      TabIndicatorProps={{ children: <span /> }}
    >
      {tabs &&
        tabs.map((item, index) => {
          return (
            <Tab
              label={renderCustomTab(item.label, index)}
              sx={{ textTransform: 'initial', minHeight: '3rem' }}
              key={`tab_item_${item.label}`}
              onClick={() => tabClickHandler(index)}
            />
          );
        })}
    </Tabs>
  );
};

export default BkTabs;
